import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ba7971e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5ba7971e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7971e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba7971e')) {
      api.createRecord('5ba7971e', component.options)
    } else {
      api.reload('5ba7971e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ba7971e&scoped=true&", function () {
      api.rerender('5ba7971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/login/index.vue"
export default component.exports